<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter1">
<a id="i_frontis">
<img alt="" class="calibre10" id="id-6085934664019861818" src="Images/img0006.jpg" title=""/>
</a><br class="calibre4"/>
<div class="caption"><a href="#/Text/Section0008#Page_36">“WE TAUGHT THOSE THAR RED DEMONS A LESSON THEY’LL NOT FORGET.”</a></div>
</div>
<p class="calibre8"><span id="pgepubid00001" title="[5]"><a id="Page_5" title="[5]"></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?d9c1e826